import I from '@/components/I'
import {SUCCESS_CODE} from '@/constants'
import {notifyPageFn, openWindow} from '@/plugins/bridge'
import {CombineIndexReq, DoMissionRes, RewardInfo, combineIndex} from '@/service/activity'
import {GetServerSideProps} from 'next'
import {useEffect, useRef, useState} from 'react'
import Module from '@/pageComponents/activity/tenCombine/module'
//@ts-ignore
import useSWR from 'swr'
import getUaParam from '@/utils/getUaParam'
import Main from '@/pageComponents/activity/tenCombine/main'
import TitleBar from '@/components/TitleBar'
import Cake from '@/pageComponents/activity/tenCombine/cake'
import RewardPopup from '@/pageComponents/activity/tenCombine/rewardPopup'
import constate from 'constate'
import {useUaParam} from '@/pages/_app'
import TenError from '@/pageComponents/activity/tenyears/error'
import {haboClickReport} from '@/plugins/habo'
import {ActivityId, CombineImage_Map, IMAGE_MAP} from '@/constants/activityCdn'
import {useDocumentVisibility, useInViewport} from 'ahooks'
import getAppNameFromPClient from '@/utils/getAppNameFromPClient'
import {Toast} from 'gotu-ui'
import initWxConfig from '@/plugins/wxConfig'
const styles = require('./style.module.less')

export const [CombineProvider, useCombine] = constate(() => {
    const [activeFraId, setActiveFraId] = useState(0)
    const [popData, setPopData] = useState<DoMissionRes | undefined | null>(undefined)
    const [popVisible, setPopVisible] = useState(false)
    const [data, setData] = useState<CombineIndexReq | null>(null)
    let {fromId, isApp} = useUaParam()
    const swiperRef = useRef<any>(null)
    const getData = async () => {
        // 兼容undefined
        if (fromId === 'undefined' || fromId === 'null') {
            fromId = undefined
        }
        const res = await combineIndex(fromId && Number(fromId), isApp)
        const {success, data} = res
        if (success && data) {
            setData(data)
        } else {
            Toast.show('获取数据失败,请刷新页面重试')
        }
    }
    return {
        activeFraId,
        setActiveFraId,
        popData,
        setPopData,
        popVisible,
        setPopVisible,
        data,
        setData,
        getData,
        swiperRef,
    }
})

const TenCombine = (props:ActivityProps) => {
    const {
        fromId,
        source,
        visualCenterPosition = 0,
        isApp,
        titleStatusBarHeight,
    } = useUaParam()
    const {
        popData,
        setPopData,
        popVisible,
        setPopVisible,
        data,
        setData,
        getData,
    } = useCombine()
    const combineRef = useRef<HTMLDivElement>(null)
    const mainRef = useRef<HTMLElement>(null)
    const childRef = useRef<HTMLElement>(null)
    const taskRef = useRef<HTMLDivElement>(null)
    const [rightShow, setRightShow] = useState(false)
    const [background, setBackgroundColor] = useState('rgba(255, 255, 255, 0)')

    useEffect(() => {
        // ssr 在服务端的请求，在端外没有sid，因此需要在客户端再请求一次 ，并且由于动画的原因，初始化之后，需要手动控制碎片数据的刷新，避免额外触发动画
        // setData(props.data)
        // getData()
        haboClickReport('十周年聚合页页面曝光', {source, focus_module: visualCenterPosition, activity_id: ActivityId})
        const payload = {
            title: '高途十周年 | 十年成长路 前行有高途',
            desc: '一起来拼蛋糕吧！超多礼品等你拿',
            link: location.href,
            imgUrl: CombineImage_Map.share_wx_icon,
        }
        initWxConfig(payload)
    }, [])
    const documentVisibility = useDocumentVisibility()
    useEffect(() => {
        if (documentVisibility === 'visible') {
            getData()
        }
    }, [documentVisibility])
    const mainInView = useInViewport(mainRef.current, {root: combineRef.current, threshold: 0.2})
    useEffect(() => {
        // 任务完成未领取，右下角提示
        if (data) {
            const {missionModule, activityPhase} = data
            // 开奖阶段不展示 可领取奖励提示
            if (missionModule && mainInView && activityPhase === 1) {
                const {missionList} = missionModule
                if (missionList && missionList.length > 0) {
                    const i = missionList.findIndex((item) => item.missionStatus === 3)
                    if (i !== -1 && !mainInView[0]) {
                        setRightShow(true)
                    } else {
                        setRightShow(false)
                    }
                }
            }
        }
        // 根据滚动位置添加背景色
        if (combineRef.current) {
            const handleScroll = () => {
                if (!combineRef.current) return
                const scrollTop = combineRef.current.scrollTop
                const opacity = Math.min(scrollTop / 44, 1)
                setBackgroundColor(`rgba(255, 255, 255, ${opacity})`)
            }
            if (combineRef.current) {
                combineRef.current.addEventListener('scroll', handleScroll)
            }
            return () => {
                if (combineRef.current) {
                    combineRef.current.removeEventListener('scroll', handleScroll)
                }
            }
        }
    }, [data, mainInView])

    if (!props.success || !props.data) return <TenError></TenError>
    if (!data) return null
    const {
        fragmentModule,
        mainButton,
        subActivityModuleList,
        missionModule,
        activityPhase,
        isLogin,
    } = data
    // 开始阶段返回
    if (activityPhase === 0) {
        return <TenError title='十周年活动尚未开始，请耐心等待'></TenError>
    }
    // 结束阶段直接返回错误页面
    if (activityPhase === 3) {
        return <TenError title='十周年活动已结束，明年再来吧~'></TenError>
    }
    const scrollModule = (type: 'main' | 'child') => {
        if (type === 'main') {
            if (mainRef.current && combineRef.current && taskRef.current) {
                combineRef.current.scrollTo({top: mainRef.current.offsetTop + taskRef.current.offsetTop - titleStatusBarHeight, behavior: 'smooth'})
            }
        } else {
            if (childRef.current && combineRef.current && taskRef.current) {
                combineRef.current.scrollTo({top: childRef.current.offsetTop + taskRef.current.offsetTop - titleStatusBarHeight, behavior: 'smooth'})
            }
        }
    }
    const goRule = () => {
        const url = `${location.origin}/book-content/activity/tenyears/rule?fromId=${fromId}`
        goUrl(url)
    }
    const goPool = () => {
        haboClickReport('十周年奖池点击', {source, activity_id: ActivityId})
        const url = `${location.origin}/book-content/activity/tenyears/gift?fromId=${fromId}`
        goUrl(url)
    }
    const goUrl = (url: string) => {
        if (isApp) {
            openWindow(url, 'hide', 'hide')
        } else {
            window.open(url)
        }
    }
    return (
        <div
            className={styles.combine}
            ref={combineRef}
        >
            <div
                className={styles['combine-bg']}
            >
                <div
                    className={styles['combine-box']}
                    style={{backgroundPosition: isApp ? '0 0' : '0 -16px'}}
                >
                    {
                        (isApp) ? (
                            <TitleBar
                                backgroundColor={background}
                                content='高途十周年'
                                hasOccupy
                            />
                        ) : <div className='h44'></div>
                    }
                    <Cake
                        mainButton={mainButton}
                        fragmentModule={fragmentModule}
                        activityPhase={activityPhase}
                        scrollModule={scrollModule}
                        combineRef={combineRef}
                    ></Cake>
                    <div
                        className='px20 z20 por'
                        ref={taskRef}
                    >
                        <Module
                            activityPhase={activityPhase}
                            childRef={childRef}
                            subActivityModuleList={subActivityModuleList}
                        ></Module>
                        <Main
                            mainRef={mainRef}
                            activityPhase={activityPhase}
                            missionModule={missionModule}
                            scrollModule={scrollModule}
                        ></Main>
                    </div>
                    <RewardPopup
                        visible={popVisible}
                        data={popData}
                        close={() => setPopVisible(false)}
                    ></RewardPopup>

                </div>
            </div>
            {
                rightShow && (
                    <div
                        className={styles['right-corn']}
                        onClick={() => scrollModule('main')}
                    >
                        <I
                            src='https://i.gsxcdn.com/2442506630_o4dj2lg0.svg'
                            width={8.6}
                            height={7.5}
                        ></I>
                        <span className='ml6'>奖励可领</span>
                    </div>
                )
            }
        </div>
    )
}

interface ActivityProps {
    code: number
    data: CombineIndexReq | null
    success: boolean
}

const Activity = (props:ActivityProps) => {
    return (
        <CombineProvider>
            <TenCombine {...props}></TenCombine>
        </CombineProvider>
    )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
    const {req} = ctx
    let {
        fromId,
        isApp,
        p_client = 1,
    } = getUaParam(req.url)
    const appName = getAppNameFromPClient(typeof p_client === 'string' ? Number(p_client) : p_client)
    if (fromId === 'undefined' || fromId === 'null') fromId = undefined
    const res = await combineIndex(fromId && Number(fromId), isApp, ctx)
    const {
        success,
        data,
        code,
    } = res
    return {
        props: {
            title: '高途十周年',
            code: SUCCESS_CODE,
            data,
            success,
            appName: appName || 'gaotu',
        },
    }
}
export default Activity
